import localeText from '@/locales/datagrid'
import { Rows2Icon, Rows3Icon, Rows4Icon } from 'lucide-react'
import { useTableApiContext } from '../../utils/table-context'
import { GridMenuButton, GridMenuItem } from './MenuComponents'

/**
 * Precisa estar no contexto do TableApiProvider
 */
export default function ToolbarDensitySelector() {
    const { density, setDensity } = useTableApiContext()

    return (
        <GridMenuButton
            startIcon={
                density === 'compact' ? (
                    <Rows4Icon />
                ) : density === 'comfortable' ? (
                    <Rows2Icon />
                ) : (
                    <Rows3Icon />
                )
            }
            label={`${localeText.toolbarDensity}`}
        >
            <GridMenuItem
                onClick={() => setDensity('compact')}
                startIcon={
                    <>
                        <Rows4Icon />
                        <div style={{ width: 5 }} />
                    </>
                }
                label={`${localeText.toolbarDensityCompact}`}
                selected={density === 'compact'}
            />
            <GridMenuItem
                onClick={() => setDensity('standard')}
                startIcon={
                    <>
                        <Rows3Icon />
                        <div style={{ width: 5 }} />
                    </>
                }
                label={`${localeText.toolbarDensityStandard}`}
                selected={density === 'standard'}
            />
            <GridMenuItem
                onClick={() => setDensity('comfortable')}
                startIcon={
                    <>
                        <Rows2Icon />
                        <div style={{ width: 5 }} />
                    </>
                }
                label={`${localeText.toolbarDensityComfortable}`}
                selected={density === 'comfortable'}
            />
        </GridMenuButton>
    )
}
